import { useContext } from 'react';
import { PurchaseMediaContext } from './PurchaseMediaProvider';
import { IUsePurchaseMediaContext } from './usePurchaseMedia.types';

export const usePurchaseMedia = () => useContext<IUsePurchaseMediaContext>(PurchaseMediaContext);
